
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host,
.horizontal-card-wrapper {
  display: flex;
}
:host .hotizontal-card-content,
.horizontal-card-wrapper .hotizontal-card-content {
  display: flex;
  flex: 0 0 100%;
  flex-direction: row;
  align-items: stretch;
  position: relative;
}
:host .hotizontal-card-content:focus-visible,
.horizontal-card-wrapper .hotizontal-card-content:focus-visible {
  outline: none;
}
:host .hotizontal-card-content:focus-visible::after,
.horizontal-card-wrapper .hotizontal-card-content:focus-visible::after {
  content: "";
  display: block;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  position: absolute;
  top: -4px;
  left: -4px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 16px;
}
:host .hotizontal-card-content .pe-xl,
.horizontal-card-wrapper .hotizontal-card-content .pe-xl {
  padding-right: 24px;
}
:host .hotizontal-card-content .content,
.horizontal-card-wrapper .hotizontal-card-content .content {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  word-break: break-word;
  padding-left: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host .hotizontal-card-content .content.left-radius,
.horizontal-card-wrapper .hotizontal-card-content .content.left-radius {
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}
:host .hotizontal-card-content .content.right-radius,
.horizontal-card-wrapper .hotizontal-card-content .content.right-radius {
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}
:host .hotizontal-card-content .content slot[name=content]::slotted(*),
.horizontal-card-wrapper .hotizontal-card-content .content slot[name=content]::slotted(*) {
  font-family: var(--slh-default-font-family, "Open Sans");
}
:host .hotizontal-card-content slot[name=icon]::slotted(*),
.horizontal-card-wrapper .hotizontal-card-content slot[name=icon]::slotted(*) {
  padding: 16px 12px;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  display: flex;
  align-items: center;
  background-color: var(--slh-color-neutral-shade-20, #EBEEF4);
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
:host .hotizontal-card-content slot[name=content],
.horizontal-card-wrapper .hotizontal-card-content slot[name=content] {
  width: 100%;
  height: 100%;
  display: block;
}
:host .hotizontal-card-content slot[name=action]::slotted(*),
.horizontal-card-wrapper .hotizontal-card-content slot[name=action]::slotted(*) {
  padding: 16px 8px;
  display: flex;
  align-items: center;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
@media screen and (max-width: 560px) {
  :host .hotizontal-card-content,
  .horizontal-card-wrapper .hotizontal-card-content {
    cursor: pointer;
  }
  :host .hotizontal-card-content .content,
  .horizontal-card-wrapper .hotizontal-card-content .content {
    flex-direction: column;
    align-items: flex-start;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    padding-right: 24px;
  }
  :host .hotizontal-card-content slot[name=action]::slotted(*),
  .horizontal-card-wrapper .hotizontal-card-content slot[name=action]::slotted(*) {
    display: none;
  }
}
`;
